import { Box, Button, Switch } from "@mui/material";
import { Link } from "react-router-dom";
import { PRIVATE_PAGES } from "@app/router/pages";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import BasicPagination from "@app/components/Pagination";

import { StyledImage, StyledTableCell } from "./styled";
import { useProductsListLogic } from "./useProductsListLogic";

const Products = () => {
  const {
    productsList,
    handleChange,
    handleDeleteProduct,
    pagesCount,
    handlePagination
  } = useProductsListLogic()

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '20px',
        flexDirection: 'column',
        alignItems: 'flex-end'
      }}
    >
      <Box display="flex" gap={1}>
        <Link to={PRIVATE_PAGES.UPDATE_PRODCUTS_ORDERING}>
          <Button variant="contained" color="primary">
            Change Ordering
          </Button>
        </Link>
        <Link to={PRIVATE_PAGES.CREATE_PRODUCTS}>
          <Button variant="contained" color="primary">
            Create Product
          </Button>
        </Link>
      </Box>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">IMAGE</TableCell>
              <TableCell align="center">TITLE AM</TableCell>
              <TableCell align="center">TITLE En</TableCell>
              <TableCell align="center">TITLE Ru</TableCell>
              <TableCell align="center">IN HOME</TableCell>
              <TableCell align="center">BEST SELLER</TableCell>
              <TableCell align="center">ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {productsList.map((product) => {
              const image = product.images.find(({ isMain }) => isMain)?.url || product.images[0]?.url

              return (
                <TableRow key={product.id}>
                  <TableCell align="center">
                    <StyledImage
                      alt="product"
                      src={`${process.env.REACT_APP_API_BASE_URL}/${image}`}
                    />
                  </TableCell>
                  <TableCell align="center">{product.titleAm}</TableCell>
                  <TableCell align="center">{product.titleEn}</TableCell>
                  <TableCell align="center">{product.titleRu}</TableCell>
                  <TableCell align="center">
                    <Switch
                      checked={product.activeInHome}
                      onChange={() => handleChange({
                        data: !product?.activeInHome,
                        key: 'activeInHome',
                        productId: product.id,
                      })}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Switch
                      checked={product.bestSeller}
                      onChange={() => handleChange({
                        data: !product?.bestSeller,
                        key: 'bestSeller',
                        productId: product.id,
                      })}
                    />
                  </TableCell>
                  <StyledTableCell align="center">
                    <Link to={`/product/${product.id}`}>
                      <Button variant="outlined">
                        Edit
                      </Button>
                    </Link>
                    <Button variant="contained" onClick={() => handleDeleteProduct(product.id)}>
                      Delete
                    </Button>
                  </StyledTableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <BasicPagination count={pagesCount} callback={handlePagination} />
    </Box>
  )
};

export default Products;
